const TABS_HEIGHT = 52;

export { TABS_HEIGHT };
